import { render, staticRenderFns } from "./RequestGraduationApproval.vue?vue&type=template&id=40797d33&scoped=true&"
import script from "./RequestGraduationApproval.vue?vue&type=script&lang=js&"
export * from "./RequestGraduationApproval.vue?vue&type=script&lang=js&"
import style0 from "./RequestGraduationApproval.vue?vue&type=style&index=0&id=40797d33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40797d33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
